<!-- 服务请求运维单表单(包括工单、服务商、客户、设备) -->
<template>
  <layui-collapse ref="collapse" class="requestForm">
    <div class="layui-colla-item">
      <h2 class="layui-colla-title">
        {{ editRow.WORK_ORDER_CATEGORY === '1' ? '服务请求运维单基本信息' : '服务请求工程单基本信息' }}
      </h2>
      <div class="layui-colla-content layui-show">
        <div class="layui-form-item-two layui-form-column">
          <div class="layui-form-colun-inner">
            <div class="layui-form-item-left">
              <div class="layui-form-item">
                <label class="layui-form-label">项目经理名称：</label>
                <label class="layui-form-label right">{{ editRow.MANAGER_NAME }}</label>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">服务方式：</label>
                <label class="layui-form-label right">{{ editRow.WORK_ORDER_METHOD_DESC }}</label>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">服务请求单来源：</label>
                <label class="layui-form-label right">{{ editRow.BILL_SOURCE_METHOD_DESC }}</label>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">服务请求单类型：</label>
                <label class="layui-form-label right">{{ editRow.WORK_ORDER_TYPE_DESC }}</label>
              </div>
              <div class="layui-form-item"  v-if="editRow.WORK_ORDER_CATEGORY == '1'">
                <label class="layui-form-label">故障类型：</label>
                <label class="layui-form-label right">{{ editRow.WRONG_TYPE_DESC }}</label>
              </div>
              <div class="layui-form-item" v-if="editRow.WORK_ORDER_CATEGORY == '1'">
                <label class="layui-form-label">SLA等级：</label>
                <label class="layui-form-label right">{{ editRow.SLA_LEVEL }}</label>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">客户联系人：</label>
                <label class="layui-form-label right">{{ editRow.CLIENT_PERSON }}</label>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">客户联系人电话：</label>
                <label class="layui-form-label right">{{ editRow.CLIENT_PERSON_PHONE }}</label>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">描述：</label>
                <label class="layui-form-label right textarea">{{ editRow.DESCRIPTION }}</label>
              </div>
            </div>
            <!-- 客户和工程师不能看到收入情况 -->
            <div
              class="layui-form-item-right"
              v-if="
                security
                  .getUser()
                  .getRoles()
                  .indexOf('kh') < 0 && 
                  security
                  .getUser()
                  .getRoles()
                  .indexOf('gcs') < 0
              "
            >
              <div class="layui-form-item">
                <label class="layui-form-label">收入金额：</label>
                <label class="layui-form-label right" v-if="editRow.ORDER_STATE != '5'">{{
                    editRow.INCOME_AMOUNT
                  }}</label>
                <div class="layui-input-inline" v-if="editRow.ORDER_STATE == '5'">
                  <input
                    type="number"
                    v-model="editRow.INCOME_AMOUNT"
                    autocomplete="off"
                    class="layui-input"
                    name="INCOME_AMOUNT"
                    placeholder="请输入收入金额"
                  />
                </div>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">收入费用状态：</label>
                <label class="layui-form-label right" v-if="editRow.ORDER_STATE != '5'">{{
                    editRow.INCOME_AMOUNT_TYPE_DESC
                  }}</label>
                <div class="layui-input-inline" v-if="editRow.ORDER_STATE == '5'">
                  <layui-radio v-model="editRow.INCOME_AMOUNT_TYPE" name="INCOME_AMOUNT_TYPE">
                    <input type="radio" value="1" title="未付款" />
                    <input type="radio" value="2" title="已付款" />
                  </layui-radio>
                </div>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">收入票据状态：</label>
                <label class="layui-form-label right" v-if="editRow.ORDER_STATE != '5'">{{
                    editRow.INCOME_BILL_TYPE_DESC
                  }}</label>
                <div class="layui-input-inline" v-if="editRow.ORDER_STATE == '5'">
                  <layui-radio v-model="editRow.INCOME_BILL_TYPE" name="INCOME_BILL_TYPE">
                    <input type="radio" value="1" title="未开票" />
                    <input type="radio" value="2" title="已开票" />
                  </layui-radio>
                </div>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">支出金额：</label>
                <label class="layui-form-label right" v-if="editRow.ORDER_STATE != '5'">{{
                    editRow.EXPENSES_AMOUNT
                  }}</label>
                <div class="layui-input-inline" v-if="editRow.ORDER_STATE == '5'">
                  <input
                    type="number"
                    v-model="editRow.EXPENSES_AMOUNT"
                    autocomplete="off"
                    class="layui-input"
                    name="EXPENSES_AMOUNT"
                    placeholder="请输入支出金额"
                  />
                </div>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">支出费用状态：</label>
                <label class="layui-form-label right" v-if="editRow.ORDER_STATE != '5'">{{
                    editRow.EXPENSES_AMOUNT_TYPE_DESC
                  }}</label>
                <div class="layui-input-inline" v-if="editRow.ORDER_STATE == '5'">
                  <layui-radio v-model="editRow.EXPENSES_AMOUNT_TYPE" name="EXPENSES_AMOUNT_TYPE">
                    <input type="radio" value="1" title="待请款" />
                    <input type="radio" value="2" title="待付款" />
                    <input type="radio" value="3" title="已付款" />
                  </layui-radio>
                </div>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">支出票据状态：</label>
                <label class="layui-form-label right" v-if="editRow.ORDER_STATE != '5'">{{
                    editRow.EXPENSES_BILL_TYPE_DESC
                  }}</label>
                <div class="layui-input-inline" v-if="editRow.ORDER_STATE == '5'">
                  <layui-radio v-model="editRow.EXPENSES_BILL_TYPE" name="EXPENSES_BILL_TYPE">
                    <input type="radio" value="0" title="劳务" />
                    <input type="radio" value="1" title="待开票" />
                    <input type="radio" value="2" title="已开票" />
                  </layui-radio>
                </div>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">备注：</label>
                <label class="layui-form-label right" v-if="editRow.ORDER_STATE != '5'">{{
                    editRow.PAYMENT_NOTE
                  }}</label>
                <div class="layui-input-inline" v-if="editRow.ORDER_STATE == '5'">
                  <div class="layui-input-inline" style="width:100%">
                    <textarea
                      v-model="editRow.PAYMENT_NOTE"
                      placeholder="请输入相关备注"
                      name="PAYMENT_NOTE"
                      class="layui-textarea"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="layui-form-bottom">
            <div class="layui-form-item">
              <label class="layui-form-label">附件：</label>
              <div class="layui-input-inline" style="width:80%">
                <layui-listfileupload v-model="editRow.ORDER_FJ_ID" :enabled="false" targetEl=".requestForm">
                </layui-listfileupload>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="layui-colla-item">
      <h2 class="layui-colla-title">客户信息</h2>
      <div class="layui-colla-content layui-show">
        <div class="layui-form-item-two">
          <div class="layui-form-item-left" style="width: 55%">
            <div class="layui-form-item">
              <label class="layui-form-label">客户：</label>
              <label class="layui-form-label right textarea">{{ editRow.CLIENT_NAME }}</label>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">品牌名称：</label>
              <label class="layui-form-label right textarea">{{ editRow.BRAND_NAME }}</label>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">门店名称：</label>
              <label class="layui-form-label right textarea">{{ editRow.STORE_NAME }}</label>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">店长姓名：</label>
              <label class="layui-form-label right">{{ editRow.STORE_MANAGER }}</label>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">联系方式：</label>
              <label class="layui-form-label right">{{ editRow.STORE_MANAGER_PHONE }}</label>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">所属地：</label>
              <label class="layui-form-label right">{{
                  (editRow.STORE_P ? editRow.STORE_P_DESC : '') +
                  '' +
                  (editRow.STORE_C ? editRow.STORE_C_DESC : '') +
                  '' +
                  (editRow.STORE_D ? editRow.STORE_D_DESC : '')
                }}</label>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">地址：</label>
              <label class="layui-form-label right">{{ editRow.STORE_A }}</label>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">备注：</label>
              <label class="layui-form-label right textarea">{{ editRow.STORE_BZ }}</label>
            </div>
          </div>
          <div class="layui-form-item-right" style="width: 45%">
            <div class="layui-form-item" style="height:100%;">
              <div id="container" class="map-box"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="layui-colla-item" v-show="editRow.WORK_ORDER_METHOD != '1' || editRow.REMOTE_PROCESS_TIME">
      <h2 class="layui-colla-title">远程处理结果</h2>
      <div class="layui-colla-content layui-show">
        <div class="layui-form-item-one">
          <div class="layui-form-item">
            <label class="layui-form-label">是否解决：</label>
            <label class="layui-form-label right">{{ editRow.REMOTE_PROCESS_RESULTS_DESC }}</label>
          </div>
          <div class="layui-form-item">
            <label class="layui-form-label">处理结果描述：</label>
            <label class="layui-form-label right">{{ editRow.REMOTE_PROCESS_DESCRIBE }}</label>
          </div>
          <div class="layui-form-item">
            <label class="layui-form-label">客户满意度：</label>
            <label class="layui-form-label right">{{ editRow.REMOTE_PROCESS_SATISFACTION_DESC }}</label>
          </div>
          <div class="layui-form-item">
            <label class="layui-form-label">处理人：</label>
            <label class="layui-form-label right">{{ editRow.REMOTE_PROCESS_PERSON }}</label>
          </div>
          <div class="layui-form-item">
            <label class="layui-form-label">处理时间：</label>
            <label class="layui-form-label right">{{ editRow.REMOTE_PROCESS_TIME }}</label>
          </div>
          <div class="layui-form-item">
            <label class="layui-form-label">备注：</label>
            <label class="layui-form-label right textarea">{{ editRow.REMOTE_PROCESS_BZ }}</label>
          </div>
          <label class="layui-form-label">附件：</label>
          <div class="layui-input-inline" style="width:80%">
            <layui-listfileupload v-model="editRow.REMOTE_PROCESS_FJ" :enabled="false" targetEl=".requestForm">
            </layui-listfileupload>
          </div>
        </div>
      </div>
    </div>
    <!-- 设备信息 -->
    <div class="layui-colla-item">
      <h2 class="layui-colla-title">设备信息</h2>
      <div class="layui-colla-content layui-show inside-table">
        <layui-table
          ref="deviceTable"
          table-name="YW_DEVICE"
          :lazy="true"
          :defaultCondition="{}"
          :page-size="5"
          :page-range="2"
          :page-options="[5, 10, 20, 50, 100]"
          :skin="'line'"
          :height="height"
          :sort="['ID:DESC']"
        >
          <div>
            <div title="序号" width="60" field="_NUMBER" align="center" fixed="left"></div>
            <layui-tableconfig :config="deviceTableList"></layui-tableconfig>
          </div>
        </layui-table>
      </div>
    </div>
  </layui-collapse>
</template>
<script>
export default {
  props: {
    editRow: {
      default: () => ({}),
      type: Object
    },
    height: { type: String, default: '260' }
  },
  data() {
    return {
      map: null,
      marker: null,
      workOrderId: '',
      deviceTableList: [
        { field: 'ORDER_TIME', title: '订单日期', width: 150 },
        { field: 'ORDER_ID', title: '订单编号', width: 130 },
        { field: 'BUSINESS_TYPE', title: '业务类别', width: 130 },
        { field: 'CLIENT', title: '客户', width: 200 },
        { field: 'BZ2', title: '备注', width: 200 },
        { field: 'COMMODITY_ID', title: '商品编码', width: 130 },
        { field: 'COMMODITY_NAME', title: '商品名称', width: 130 },
        { field: 'COMMODITY_TYPE', title: '商品型号', width: 130 },
        { field: 'COMMODITY_BRAND', title: '商品品牌', width: 130 },
        { field: 'MEASURE', title: '单位', width: 80 },
        { field: 'NUM', title: '数量', width: 80 },
        { field: 'WAREHOUSE', title: '仓库', width: 130 },
        { field: 'BZ', title: '备注', width: 130 }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (Object.keys(this.editRow).length > 0) {
        if (this.editRow.LNG && this.editRow.LAT) {
          var arriveCoor = []
          arriveCoor.push(this.editRow.LNG)
          arriveCoor.push(this.editRow.LAT)
          this.addMarker(arriveCoor)
        }
        this.$refs.deviceTable.defaultCondition.WORK_ORDER_ID = this.editRow.WORK_ORDER_ID
        this.$refs.deviceTable.load()
      }
    })
  },
  methods: {
    // 坐标定位
    addMarker(arriveCoor) {
      this.map = new AMap.Map('container', {
        resizeEnable: true,
        zoom: 16,
        center: arriveCoor
      })
      //鹰眼
      //this.map.addControl(new AMap.OverView());
      //比例尺
      this.map.addControl(new AMap.Scale())
      //工具条
      this.map.addControl(new AMap.ToolBar({ liteStyle: true }))
      this.marker = new AMap.Marker({
        imageSize: '20px',
        position: arriveCoor,
        offset: new AMap.Pixel(-13, -30),
        // 设置是否可以拖拽
        draggable: false,
        cursor: 'move',
        // 设置拖拽效果
        raiseOnDrag: false
      })
      this.marker.setMap(this.map)
      this.map.setFitView()
    }
  }
}
</script>
<style scoped>
.inside-table >>> .layui-form {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/workOrder/detailForm/workOrderForm.vue